import MinicartComponent from "../vue/components/MinicartComponent";
import store from "@continente/vue/components/store";
import { getSVGIcon } from "../utilities/globalUtilities";

const initVueMinicart = (el, minicartData) => {
    const resources = minicartData.resources;
    const brandID = minicartData.brandID;
    const minimumOrderValueBlocked = minicartData.basket.isMiniCartMinimumOrderValueBlocked;
    const minicartDataLayerObject = JSON.stringify(minicartData.pageDataLayer);
    let { items, itemsSortedByBrand, numItems, totals } = minicartData.basket;
    let {totalPriceProductsOnly} = totals || {};
    let subTotal = totalPriceProductsOnly;
    let hideZeroPrice = totals && totals.hideZeroPrice ? totals.hideZeroPrice : false;
    let isCartEmpty = !numItems;
    const campaignBenefitThreshold = resources.campaignBenefitThreshold;

    store.commit("setBasketInfo", minicartData.basket);

    /**
     * Component data
     */
    const data = () => {
        return {
            itemsSortedByBrand: itemsSortedByBrand,
            items,
            resources,
            brandID,
            minimumOrderValueBlocked,
            totals,
            subTotal,
            campaignBenefitThreshold,
            hideZeroPrice,
            isCartEmpty,
            minicartDataLayerObject,
            infoIcon: getSVGIcon("icon-information", ".svg-icons-container"),
            closeIcon: getSVGIcon("icon-close", ".svg-icons-container"),
            cartIcon: getSVGIcon("icon-cart", ".svg-icons-container"),
            emptyCartIcon: getSVGIcon("icon-cart-empty", ".svg-icons-container"),
            trashIcon: getSVGIcon("icon-trash", ".svg-icons-container"),
            areaEntregaIcon: getSVGIcon("icon-entrega-zero"),
            activeAreaEntregaIcon: getSVGIcon("icon-success"),
            arrowUpIcon: getSVGIcon("icon-arrow-up", ".svg-icons-container"),
            arrowDownIcon: getSVGIcon("icon-arrow-down", ".svg-icons-container"),
            brandsIcons: {
                col: getSVGIcon("icon-logo-col", ".svg-icons-container"),
                zu: getSVGIcon("icon-logo-zu", ".svg-icons-container")
            },
            quantityInputIcons: {
                plusIcon: "<i class='css-math-plus'></i>",
                minusIcon: "<i class='css-math-minus'></i>"
            }
        };
    };

    /**
     * Component mounted function
     */
    const mounted = function () {
        store.watch(() => store.state.basketInfo, newBasket => {
            this.items = newBasket.items;
            this.itemsSortedByBrand = newBasket.itemsSortedByBrand;
            this.totals = newBasket.totals;
            this.subTotal = newBasket.totals.totalPriceProductsOnly || {};
            this.hideZeroPrice = newBasket.totals.hideZeroPrice || false;
            this.isCartEmpty = newBasket.numItems == 0;
        });
    };

    new MinicartComponent({el, store, data, mounted});
};

export { initVueMinicart };
